import { useState } from 'react'
import style from './style.module.scss'
import { motion } from 'framer-motion'

interface Props {
  baseItem?: number
  list: string[]
  onChange: (index: number) => void
  name: string
}

const Tabs = ({ list, onChange, baseItem, name }: Props) => {
  const [active, setActive] = useState(baseItem || 0)

  const handleClick = (i: number) => {
    setActive(i)
    onChange(i)
  }

  return (
    <div className={style.tabs}>
      {list.map((item, index) => (
        <motion.span
          transition={{ duration: 0.3 }}
          className={index === active ? 'active' : ''}
          key={index}
          onClick={() => handleClick(index)}
        >
          {item}
          {index === active && <motion.i initial={false} className={style.switch} layoutId={name}></motion.i>}
        </motion.span>
      ))}
    </div>
  )
}

export default Tabs
